import React, { Component } from "react";
import './LiveClock.css';

class LiveClock extends Component {
  constructor(props) {
    super(props);

    this.state = { date: new Date() };
  }

  componentDidMount() {
    this.tick()
    this.timerID = setInterval(() => this.tick(), 60000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    let date= new Date()
    this.setState({
      date: date
    });
  }

  getMarginTop(date) {
    let h = date.getHours();
    let m = date.getMinutes();

    let marginTop=(0.75+((h-5)*3.4)+((m/60)*3.4))
    let marginTopString=marginTop+"vw"

    return marginTopString
  }

  render() {
    return (
      <div style={{"marginTop": this.getMarginTop(this.state.date)}} className="liveClock">
      </div>
    );
  }
}

export default LiveClock;
